import { defineComponent as _defineComponent } from 'vue'
import { User } from "@/CodegenTypes";
import { mutations, queries } from "@/apollo";
import { clone } from "lodash";
import { errorMutationNotification } from "@/utils";
import { onMounted, ref, watch } from "vue";
import { apolloClient } from "@/apollo";
import { addSuccessToast } from "@/vue-service";
import { maskMobile } from "@/helpers/maskMobile";
import { useTranslation } from "@/store/translation";


export default /*#__PURE__*/_defineComponent({
  __name: 'MobileSettingFormModal',
  props: {
    user: null,
    value: { type: Boolean }
  },
  emits: ["input"],
  setup(__props: any, { emit }) {

const props = __props as { user: User; value: boolean };

const form = ref(getDefaultForm());

const { $t } = useTranslation();




onMounted(() => {
  resetForm();
});

function toggleModal(val: boolean) {
  emit("input", val);
}

function getDefaultForm() {
  return clone({
    mobile1: maskMobile(props.user.mobile1),
    mobile2: maskMobile(props.user.mobile2),
    mobile3: maskMobile(props.user.mobile3),
  });
}

function resetForm() {
  form.value = getDefaultForm();
}

watch(
  () => props.user,
  () => {
    resetForm();
  }
);

async function handleSubmit() {
  try {
    const result = await apolloClient.mutate({
      mutation: mutations.updateMobileSetting,
      variables: {
        payload: {
          behalfOf: props.user.userId,
          mobile1: form.value.mobile1.includes("*")
            ? props.user.mobile1
            : form.value.mobile1,
          mobile2: form.value.mobile2.includes("*")
            ? props.user.mobile2
            : form.value.mobile2,
          mobile3: form.value.mobile3.includes("*")
            ? props.user.mobile3
            : form.value.mobile3,
        },
      },
      refetchQueries: [
        {
          query: queries.userWithDownlines,
          variables: {
            userId: props.user.uplineId,
          },
        },
        {
          query: queries.me,
        },
      ],
    });
    addSuccessToast("Mobile updated.");
    toggleModal(false);
  } catch (err) {
    errorMutationNotification(err);
  }
}

return { __sfc: true,form, $t, props, emit, toggleModal, getDefaultForm, resetForm, handleSubmit }
}

})